<template>
  <div class="container-list">
    <!-- 列表主体 -->
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive table-custom">
          <table
            class="table project-list-table table-nowrap align-middle table-borderless"
          >
            <!-- 表格头部 -->
            <thead>
              <tr>
                <th scope="col" class="title-font extra-padding-left">
                  REGISTRATION DAY<span @click="toggleSort"
                    ><i class="bi bi-arrow-down-up icon-control"></i
                  ></span>
                </th>
                <th scope="col" class="title-font">REGISTRATION TIME</th>
                <th scope="col" class="title-font">TASK</th>
                <th scope="col" class="title-font">CATEGORY</th>
                <th scope="col" class="title-font">PUNCH IN</th>
                <th scope="col" class="title-font">PUNCH OUT</th>
                <th scope="col" class="title-font">WORKING HOURS</th>
                <th scope="col" class="title-font extra-padding-right">
                  Action
                </th>
              </tr>
            </thead>
            <div></div>
            <!-- 表格数据 -->
            <tbody>
              <!-- 假的示意圖 -->
              <tr>
                <th scope="row" class="ps-4 extra-padding-left">2024-01-10</th>
                <td>
                  <span>16:00</span>
                  <!-- <br /><span class="time-gray">17:00</span> -->
                </td>
                <td>Chapter 4</td>
                <td>
                  <span class="badge badge-soft-success mb-0">Education</span>
                </td>
                <td>2024-01-10 16:00</td>
                <td>2024-01-10 17:30</td>
                <td><span>1</span>hr <span>30</span>min</td>
                <td>
                  <ul>
                    <li class="list-inline-item action-icon-left">
                      <a
                        href="javascript:void(0);"
                        title="play"
                        class="text-dark"
                        ><i
                          class="bi bi-play-circle-fill"
                          @click="openTaskModal(task)"
                        ></i
                        ><span class="spans-pace"></span
                      ></a>
                    </li>
                  </ul>
                </td>
              </tr>
              <!-- 循环渲染每个任务 -->
              <tr v-for="(task, index) in sortedAndFilteredTasks" :key="index">
                <th scope="row" class="ps-4 extra-padding-left">
                  {{ task.day }}
                </th>
                <td>
                  <span>{{ task.time }}</span>
                </td>
                <td>{{ task.title }}</td>
                <td>
                  <span class="badge badge-soft-success mb-0">{{
                    task.category
                  }}</span>
                </td>
                <td>{{ formatDate(task.punchInTime) }}</td>
                <td>{{ formatDate(task.punchOutTime) }}</td>
                <td>{{ task.workingHours }}</td>
                <td>
                  <ul>
                    <li class="list-inline-item action-icon-left">
                      <a
                        href="javascript:void(0);"
                        title="Action"
                        class="text-dark"
                      >
                        <!-- 这里可以根据实际需求添加图标或文字 -->
                        <i
                          class="bi bi-play-circle-fill"
                          @click="openTaskModal(task)"
                        ></i>
                        <span class="spans-pace"></span>
                      </a>
                    </li>
                  </ul>
                </td>
                <!-- 添加新任务的按钮 -->
              </tr>

              <tr>
                <td colspan="8" class="text-center">
                  <button
                    class="btn btn-white btn-new-task"
                    @click="showNewTaskPopup"
                  >
                    + New Task
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "BaseList",
  data() {
    return {
      showPopup: false,
      sortDirection: "asc",
    };
  },
  props: {
    tasks: {
      type: Array,
      default: () => [], // 提供一个函数返回空数组作为默认值
    },
    searchQuery: {
      type: String,
      default: "", // 同样为searchQuery提供默认值
    },
  },

  computed: {
    sortedAndFilteredTasks() {
      return this.tasks
        .filter((task) =>
          task.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        .sort((a, b) => {
          const dateA = new Date(a.day);
          const dateB = new Date(b.day);
          return this.sortDirection === "asc" ? dateA - dateB : dateB - dateA;
        });
    },
  },
  methods: {
    showNewTaskPopup() {
      this.$emit("openNewTaskModal");
    },
    toggleSort() {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      // 注意：我们不再直接在这里对 tasks 进行排序
    },
    openTaskModal(task) {
      // 如果点击的是示意图行，设置硬编码数据
      if (!task) {
        // 假定示意图行没有传递task对象
        const hardcodedTask = {
          title: "Chapter 4",
          startTime: "2024-01-10 16:00",
          endTime: "2024-01-10 17:30",
          category: "Education",
        };
        this.$emit("openTaskModal", hardcodedTask);
      } else {
        this.$emit("openTaskModal", task); // 向父组件发送事件及任务详情
      }
    },

    formatDate(date) {
      // 检查 date 是否是有效的日期
      if (!date || isNaN(new Date(date).getTime())) {
        return ""; // 如果不是有效日期，返回空字符串或默认值
      }
      return format(new Date(date), "yyyy-MM-dd HH:mm");
    },
  },
};
</script>

<style scoped>
.project-list-table th {
  font-weight: normal; /* 设置字体为正常粗细 */
  font-size: 14px; /* 设置字体大小与其他单元格相同 */
}
.project-list-table {
  border-collapse: separate;
  border-spacing: 0 12px;
  font-size: 14px; /* 设置较小的字体大小 */
  overflow: hidden; /* 隐藏溢出的内容，使得圆角可见 */
}
.project-list-table thead tr:first-child th:first-child,
.project-list-table tbody tr:first-child td:first-child {
  border-top-left-radius: 10px; /* 设置左上角圆角 */
}
.project-list-table thead tr:first-child th:last-child,
.project-list-table tbody tr:first-child td:last-child {
  border-top-right-radius: 10px; /* 设置右上角圆角 */
}
.project-list-table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px; /* 设置左下角圆角 */
}
.project-list-table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px; /* 设置右下角圆角 */
}
.extra-padding-left {
  padding-left: 50px !important; /* 或者您想要的任何具体数值 */
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.bi-play-circle-fill {
  font-size: 20px; /* 放大图标 */
}
.spans-pace {
  margin-right: 20px; /* 在图标和随后的文本之间添加一些间隔 */
}
.btn-new-task {
  width: 100%; /* 使按钮占据整个单元格的宽度 */
  border: none; /* 移除边框 */
  background-color: #fff; /* 设置与表格相同的背景色 */
  color: #000; /* 设置文本颜色 */
  text-align: center; /* 文本居中对齐 */
}
.btn-new-task:hover {
  background-color: #fcf9f9 !important; /* 鼠标悬停时的文本颜色 */
}
.icon-control {
  font-size: 0.75rem;
  padding-left: 5px;
}

.badge-soft-success {
  color: #63ad6f !important;
  background-color: #eff7f0 !important;
}
</style>
